import { desenhaTro } from './Aux.js';

export const dopoRank = (ling, map, rows, l1, l2, l3, l4, ind, shortv) => {
    if (!map || !rows || rows.length === 0) {
        if (rows && rows.length === 0) pompAlertaDados(ling);
        return;
    }
    let cor = '#008000';
    let ponto = rows[0];
    let campo = Object.keys(ponto);
    for (let i = 0; i < rows.length; i++) {
        if (i === l1){
            cor = '#00FF00';
        }
        if (i === l2){
            cor = '#FFDF00';
        }
        if (i === l3){
            cor = '#FF8C00';
        }
        if (i === l4){
            cor = '#FF0000';
        }
        desenhaTro(rows[i], cor, 4, map);
    }
    let desde = " De " + Math.round(rows[l1-1][campo[ind]]).toLocaleString('en-US') + " a ";
    let ate = Math.round(rows[0][campo[ind]]).toLocaleString('en-US') + " " + shortv;
    document.getElementById("verdescuro").innerHTML = desde + ate + " (ranking 1 a " + l1 + ")";
    desde = " De " + Math.floor(rows[l2-1][campo[ind]]).toLocaleString('en-US') + " a ";
    ate = Math.round(rows[l1][campo[ind]]).toLocaleString('en-US') + " " + shortv;
    document.getElementById("verdeclaro").innerHTML = desde + ate + " (ranking " + l1 + " a " + l2 + ")";
    desde = " De " + Math.round(rows[l3-1][campo[ind]]).toLocaleString('en-US') + " a ";
    ate = Math.round(rows[l2][campo[ind]]).toLocaleString('en-US') + " " + shortv;
    document.getElementById("amarelo").innerHTML = desde + ate + " (ranking " + l2 + " a " + l3 + ")";
    desde = " De " + Math.floor(rows[l4-1][campo[ind]]).toLocaleString('en-US') + " a ";
    ate = Math.round(rows[l3][campo[ind]]).toLocaleString('en-US') + " " + shortv;
    document.getElementById("laranja").innerHTML = desde + ate + " (ranking " + l3 + " a " + l4 + ")";
    desde = " De " + Math.round(rows[81][campo[ind]]).toLocaleString('en-US') + " a ";
    ate = Math.round(rows[l4][campo[ind]]).toLocaleString('en-US') + " " + shortv;
    document.getElementById("vermelho").innerHTML = desde + ate + " (ranking " + l4 + " a 83)";
}

export const dopoInterv = (ling, map, rows, l1, l2, l3, l4, ind, fvarT, nv, shortv) => {
    if (!map || !rows || rows.length < 1) {
        if (rows && rows.length === 0) pompAlertaDados(ling);
        return;
    }
    let num;
    let ponto = rows[0];
    let campo = Object.keys(ponto);    
    for (let i = 0; i < rows.length; i++) {
        num = rows[i][campo[ind]];
        var cor = '#008000';
        if (document.getElementById("intervT").checked) {
            if ((i>14 && i < 63) | i>70 ) {
                num = rows[i][campo[[fvarT[nv]]]];
            }
        }
        if (num<l1){
            cor = '#00FF00';
        }
        if (num<l2){
            cor = '#FFDF00';
        }
        if (num<l3){
            cor = '#FF8C00';
        }
        if (num<l4){
            cor = '#FF0000';
        }
        desenhaTro(rows[i], cor, 4, map);
    }
    let desde = " De 9,999,999 a ";
    let ate = l1.toLocaleString('en-US') + " " + shortv;
    document.getElementById("verdescuro").innerHTML = desde + ate;
    desde = " De " + l1.toLocaleString('en-US') + " a ";
    ate = l2.toLocaleString('en-US') + " " + shortv;
    document.getElementById("verdeclaro").innerHTML = desde + ate;
    desde = " De " + l2.toLocaleString('en-US') + " a ";
    ate = l3.toLocaleString('en-US') + " " + shortv;
    document.getElementById("amarelo").innerHTML = desde + ate;
    desde = " De " + l3.toLocaleString('en-US') + " a ";
    ate = l4.toLocaleString('en-US') + " " + shortv;
    document.getElementById("laranja").innerHTML = desde + ate;
    desde = " De " + l4.toLocaleString('en-US') + " a ";
    ate = "0 " + shortv;
    document.getElementById("vermelho").innerHTML = desde + ate;
}

function pompAlertaDados(ling) {
    if (ling === 'pt') {
        alert ('Não há dados para o período especificado! Só de Jan 2016 a Fev 2021, inc. para todos os dias e para Nov 2016 a Fev 2021, inc. para dias úteis.');
    } else {
        alert ('No data for the specified period! Only for Jan 2016 to Feb 2021, inc. (for all days) and for Nov 2016 to Feb 2021, inc. (for week days).')
    }
}